import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttrIndexService } from 'app/services/attr-index.service';
import { GivColumnDomain } from 'app/services/domain.service';
import { EditService } from 'app/services/edit.service';

interface EditCardColumn {
	prop: string;
	name: string;
	info;
	isDisplay?;
}

@Component({
  selector: 'app-interlayer-card',
  templateUrl: './interlayer-card.component.html',
  styleUrls: ['../../content-edit/edit-card/edit-card.component.css', './interlayer-card.component.css']
})
export class InterlayerCardComponent implements OnInit {

	@Input() currentList: any[] = [];
	@Input() editedListLength: number;
	@Input() selectionListLength: number;

	@Output() onChangeDisplayMode: EventEmitter<{}> = new EventEmitter();

	isEditedListCurrent: boolean;

	selectedRecord;
	columns: EditCardColumn[];

	disableEditing: boolean;
	commitDisableReason = ''; // TODO

	domainsByColumn: {
		[prop: string]: GivColumnDomain;
	}

	stateColStandard: string;
	countyColStandard: string;
	neighborOption = 'get_neighbor';

	isEditedCol: string;
	toDeleteCol: string;
	constructor(
		private attrIndexService: AttrIndexService,
		private editService: EditService
	) { }
	changeDisplayMode() {
		this.onChangeDisplayMode.emit({
			isEditedListCurrent: this.isEditedListCurrent
		})
	}

	discard() {}
	commit() {}

	onChange() {}

	onChangeStateOrCounty() {}


	checkValueInDomain(col: EditCardColumn) {
		if (!this.selectedRecord[col.prop] && this.selectedRecord[col.prop] !== 0) {
			return;
		}
		const domain = this.domainsByColumn[col.prop];
		if (domain && domain.type === 'list') {
			if (!domain.list) {
				return;
			}
			let idx = domain.list.indexOf(this.selectedRecord[col.prop]);
			if (idx < 0 && col.info.neighborList) {
				idx = col.info.neighborList.indexOf(this.selectedRecord[col.prop]);
			}
			if (idx < 0) {
				return false;
			} else {
				return true;
			}
		}
	}
	checkFieldDirty(col: EditCardColumn) {
		if (this.selectedRecord[this.attrIndexService.originalDataKey]) {
			return this.editService.hasValueChanged(this.selectedRecord[col.prop], this.selectedRecord[this.attrIndexService.originalDataKey][col.prop]);
		}
	}
	checkCommitDisabled() {
		// TODO
	}
	goPrevRecord() {
		const idx = this.currentList.indexOf(this.selectedRecord);
		if (idx <= 0) {
			return;
		}
		this.changeSelectedRecord(this.currentList[idx - 1]);
	}
	goNextRecord() {
		const idx = this.currentList.indexOf(this.selectedRecord);
		if (idx >= this.currentList.length - 1) {
			return;
		}
		this.changeSelectedRecord(this.currentList[idx + 1]);
	}

	private changeSelectedRecord(rec) {
		// TODO
	}
	ngOnInit() {
	}

}
